import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/dashboard', icon: '📁', label: 'I miei progetti', end: true },
  { to: '/dashboard/new-project', icon: '➕', label: 'Nuovo progetto' },
];

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div><img src='/Logo_or.png' alt='logoEsg' style={{width:'50%'}} /></div>
        </div>
        <nav style={{ flex: 1 }}>
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
          <div className="nav-section" style={{ marginTop: 16 }}>Account</div>
          <NavLink to="/setup" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="icon">🏢</span> Profilo azienda
          </NavLink>
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-user-name">{user?.email?.split('@')[0]}</div>
            <div className="sidebar-user-role">{user?.company?.name || user?.email}</div>
          </div>
          <button onClick={handleLogout} className="btn btn-ghost btn-sm" style={{ marginTop: 10, width: '100%' }}>
            Esci
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
